import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { externalEntityIntegrationPlugin } from '@internal/backstage-plugin-external-entity-integration';
import { configApiRef, microsoftAuthApiRef, useApi } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { techDocsReportIssueAddonModule, techDocsExpandableNavigationAddonModule } from '@backstage/plugin-techdocs-module-addons-contrib/alpha';
import { techDocsMermaidAddonModule } from "backstage-plugin-techdocs-addon-mermaid";
import { scaffolderCustomizations } from './scaffolder/scaffolderModule';
import { systemDataClassificationPlugin } from 'backstage-plugin-simcorp';
import { b2cFrontendPlugin } from '@internal/plugin-b2c-plugin';
import { certInventoryPlugin } from '@internal/plugin-cert-inventory';
import { filteredCatalogApiPlugin } from './apis';
import adrPlugin from '@backstage-community/plugin-adr/alpha';
import { adrModule } from './modules/adr/adrModule';
import authPlugin from '@backstage/plugin-auth';
import azureDevOpsPlugin from '@backstage-community/plugin-azure-devops/alpha';
import { catalogModule } from './modules/catalog/catalogModule';

const signInPage = SignInPageBlueprint.make({
    params: {
        loader: async () => props => {
        const configApi = useApi(configApiRef);

              const microsoftProvider = {
                id: 'microsoft-auth-provider',
                title: 'Azure AD',
                message: 'Sign in using Azure AD',
                apiRef: microsoftAuthApiRef
              };
              if (configApi.getString('auth.environment') === 'development') {
                return (<SignInPage {...props} providers={[
                  'guest',
                  microsoftProvider,
                ]} />)
              }
              return (<SignInPage {...props} provider={microsoftProvider} />)
            },
    },
});

export default createApp({
    features: [
        filteredCatalogApiPlugin,
        catalogPlugin,
        catalogModule,
        navModule,
        externalEntityIntegrationPlugin,
        createFrontendModule({
            pluginId: 'app',
            extensions: [signInPage],
        }),
        techDocsReportIssueAddonModule,
        techDocsMermaidAddonModule,
        techDocsExpandableNavigationAddonModule,
        scaffolderCustomizations,
        systemDataClassificationPlugin,
        azureDevOpsPlugin,
        b2cFrontendPlugin,
        certInventoryPlugin,
        adrPlugin,
        adrModule,
        authPlugin,
    ],
});
